import mockedCriminal from './mock/criminal.json'
import mockedAutoras from './mock/autoras.json'
import mockedOtros from './mock/otros.json'
import mockedIlustrado from './mock/ilustrado.json'

const axios = require('axios')

export const requestsMixin = {
  methods: {
    async fetchWorks (category, page = 1) {
      return this.fetch('works', category, page)
        .then(value => { return value.works })
    },
    async fetchArticles (category = 'list', page = 1) {
      return this.fetch('articles', category, page)
        .then(value => { return value.articles })
    },
    async fetch (entity, category, page = 1) {
      if (!this.$feature('useApi')) {
        console.log(`mixin: [MOCKED] Fetching entity=${entity} category=${category} page=${page}`)
        const data = await this.loadMockData(category, page)
        return data
      }
      try {
        const url = `${this.$appConfig.apiBaseUrl}/${entity}/${category}.json?page=${page}`
        // console.log(`mixin: Fetching ${entity} from ${url}`)
        const response = await axios.get(url)
        return response.data
      } catch (err) {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          console.log('Server Error:', err)
        } else if (err.request) {
          // client never received a response, or request never left
          console.log('Network Error:', err)
        } else {
          console.log('Client Error:', err)
        }
      }
    },
    async loadMockData (category, page) {
      if (page > 1) return []

      switch (category) {
        case 'criminal': return mockedCriminal
        case 'autoras': return mockedAutoras
        case 'ilustrado': return mockedIlustrado
        case 'otros': return mockedOtros
        default: return []
      }
    }
  }
}
